import {
  Grid,
  AppBar,
  Button,
  ButtonGroup,
  Toolbar,
  Hidden,
  Fab,
  Menu,
  MenuItem,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Chip,
  Avatar,
} from "@material-ui/core";
import React from "react";
//icons
import { IoIosArrowDown } from "react-icons/io";
import { TiThMenu } from "react-icons/ti";
import logo from "../../images/logo.png";
import logoBanader from "../../images/logoBanader.png";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import sarLogo from "../../images/sarLogo.png";
import serviceLogo from "../../images/serviceLogo.png";
import pollutionLogo from "../../images/pollutionLogo.png";
import DredgingIcon from "../../images/DredgingIcon.png";
import signIcon from "../../images/signIcon.jpg";
import communicationIcon from "../../images/communicationIcon.jpg";
import hydrographyIcon from "../../images/hydrographyIcon.jpg";

// context
// import { useLayoutDispatch, useLayoutState } from "../../context/LayoutContext";
// import { useUserDispatch } from "../../context/UserContext";

// styles
import useStyles from "./styles";

//components
import { Link } from "react-router-dom";
import clsx from "clsx";

const Service = ({ link, image, title, description, ...props }) => {
  var classes = useStyles();

  return (
    <div>
      <Link to={"/app/" + link}>
        <div className={classes.serviceContainer} {...props}>
          <img src={image} alt="services" className={classes.serviceImage} />
          <div className={classes.serviceTitle}>{title}</div>
          <div className={classes.serviceDescription}>{description}</div>
        </div>
      </Link>
    </div>
  );
};
const ServiceOnMobile = ({ link, image, title, ...props }) => {
  var classes = useStyles();

  return (
    <Grid container justify="center">
      <Link to={"/app/" + link}>
        <Chip
          avatar={<Avatar alt="sarLogo" src={image} />}
          label={title}
          {...props}
        />
      </Link>
    </Grid>
  );
};

const servicesList = [
  { link: "SAR", title: "SAR", description: "description", image: sarLogo },
  {
    link: "pollution",
    title: "pollution",
    description: "description",
    image: pollutionLogo,
  },
  {
    link: "sign",
    title: "sign",
    description: "description",
    image: signIcon,
  },
  {
    link: "main",
    title: "Hydrography",
    description: "description",
    image: hydrographyIcon,
  },
  {
    link: "main",
    title: "Dredging",
    description: "description",
    image: DredgingIcon,
  },
  {
    link: "main",
    title: "Communication",
    description: "description",
    image: communicationIcon,
  },
  {
    link: "main",
    title: "Public law convention",
    description: "description",
    image: serviceLogo,
  },
];

export default function Header(props) {
  var classes = useStyles();

  // global
  // var layoutState = useLayoutState();
  // var layoutDispatch = useLayoutDispatch();
  // var userDispatch = useUserDispatch();

  //mobileMenu
  const [mobileMenu, setMobileMenu] = React.useState(null);
  const [serviceListShow, setServiceListShow] = React.useState(false);
  const mobileMenuOpen = Boolean(mobileMenu);
  const mobileMenuHandle = (event) => {
    setMobileMenu(event.currentTarget);
  };
  const mobileMenuHandleClose = () => {
    setMobileMenu(null);
  };

  return (
    <AppBar position="static" className={classes.appBar}>
      <Toolbar className={classes.toolbar}>
        <img src={logoBanader} alt="logo" className={classes.logoBanader} />
        <span className={clsx("mainTitle", classes.title)}>
          Chabahar Safety and Marine Enviroment Protection Dep.
        </span>
        {/* <img src={logo} alt="logo" className={classes.logo} /> */}
        <div className={classes.grow} />
        <Hidden smDown>
          <div className={classes.menu}>
            <ButtonGroup
              variant="text"
              // color="primary"
              aria-label="Header menu"
            >
              <Button>Help</Button>
              <Button>Contact Us</Button>
              <Button>Tessa</Button>
            </ButtonGroup>
          </div>
          <div className={classes.selectService}>
            <Button
              variant="outlined"
              size="small"
              className={classes.button}
              endIcon={<IoIosArrowDown />}
              onClick={() => setServiceListShow(!serviceListShow)}
            >
              More Services
            </Button>
          </div>
          {serviceListShow ? (
            <div className={classes.servicesList}>
              {servicesList.map(function (item) {
                return (
                  <Service
                    image={item.image}
                    title={item.title}
                    description={item.description}
                    link={item.link}
                    onClick={() => setServiceListShow(!serviceListShow)}
                  />
                );
              })}
            </div>
          ) : null}
        </Hidden>
        <div className={classes.toggleMenuButton}>
          <Fab size="small" onClick={mobileMenuHandle}>
            <TiThMenu size="1.5rem" />
          </Fab>
        </div>

        <Menu
          id="long-menu"
          anchorEl={mobileMenu}
          keepMounted
          open={mobileMenuOpen}
          onClose={mobileMenuHandleClose}
          PaperProps={{
            style: {
              // maxHeight: ITEM_HEIGHT * 4.5,
              width: "90vw",
              background: "#d4d4d4",
            },
          }}
        >
          <MenuItem style={{ background: "#d4d4d4" }}>
            <Accordion style={{ width: "100%" }}>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1a-content"
                id="panel1a-header"
              >
                More Services
              </AccordionSummary>
              <AccordionDetails style={{ flexDirection: "column" }}>
                {servicesList.map(function (item) {
                  return (
                    <>
                      <ServiceOnMobile
                        image={item.image}
                        title={item.title}
                        description={item.description}
                        link={item.link}
                        onClick={mobileMenuHandleClose}
                      />
                      <br />
                    </>
                  );
                })}
              </AccordionDetails>
            </Accordion>
          </MenuItem>
        </Menu>
      </Toolbar>
    </AppBar>
  );
}
